import { useState, useEffect } from 'react';
import { contentfulClient } from '../lib/contentful';

export function useBlogPosts() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await contentfulClient.getEntries({
          content_type: 'blogPost',
          order: '-fields.publishDate',
        });
        
        
        if (!response.items?.length) {
          console.warn('No posts found in Contentful');
        }

        const formattedPosts = response.items.map(item => {
          return {
            slug: item.fields.slug,
            title: item.fields.title,
            excerpt: item.fields.excerpt,
            coverImage: item.fields.coverImage?.fields?.file?.url 
              ? `https:${item.fields.coverImage.fields.file.url}` 
              : '',
            date: item.fields.publishDate,
            author: item.fields.author,
            content: item.fields.content,
            seoDescription: item.fields.seoDescription,
            tags: Array.isArray(item.fields.tags)
              ? item.fields.tags
              : JSON.parse(item.fields.tags || '[]'),
            relatedPosts: item.fields.relatedPosts?.map(post => post.fields.slug) || []
          };
        });

        setPosts(formattedPosts);
      } catch (err) {
        console.error('Error details:', {
          message: err.message,
          stack: err.stack,
          response: err.response
        });
        setError(err);
      } finally {
        setIsLoading(false);
      }
    }

    fetchPosts();
  }, []);

  return { posts, isLoading, error };
} 